import React from 'react';
import './Loader.scss';

interface LoaderProps {
    size?: number;
    color?: string;
    className?: string;
    speed?: number;
    small?: boolean;
}

export const Loader: React.FC<LoaderProps> = ({ size = 50, color = '#19147e', className = '', speed = 1, small = false }) => {
    const style = {
        width: `${size}px`,
        height: `${size}px`,
        background: color,
        animationDuration: `${speed}s`
    };

    return <div className={`loader ${className} ${small ? 'small' : ''}`} style={style} />;
};
